import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { envService } from "./config/env";

import App from "./App";

Sentry.init({
  dsn: envService.getValue("VITE_SENTRY_DSN"),
  environment: envService.getValue("VITE_APP_ENV"),
  release: envService.getValue("VITE_AWS_JOB_ID"),
  initialScope: {
    tags: {
      buildTime: envService.getValue("VITE_AWS_BUILD_TIME"),
    },
  },
  enabled: !envService.isLocal(),
});

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
